<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <!-- <feather-icon icon="ArrowUpCircleIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="resendRecord" /> -->
      <feather-icon icon="ListIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="$router.push(url)" />
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="UsersIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="friendRecord" />
      <!--feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /-->
    </div>
</template>

<script>
import firebase from '@/services/saleData'
import 'firebase/database'
const axios = require('axios').default;
export default {
  name: 'CellRendererActions',
  computed: {
    url () {
      return `/management/user/${this.params.data.key}`
    }
  },
  methods: {
    editRecord () {
      //this.$router.push(`/management/user/form/${this.params.data.code}`).catch(() => {})
      console.log(this.params.data.key);
      this.$store.commit('userManagement/SET_SELECTED', this.params.data);
      this.$store.commit('userManagement/SET_POPUP', true);
    },
    friendRecord() {
      console.log(this.params.data.key);
      this.$store.dispatch('userManagement/getUsersOption').catch(err => { console.error(err) })
      this.$store.commit('userManagement/SET_SELECTED2', this.params.data);
      this.$store.commit('userManagement/SET_POPUP2', true);
    },
    resendRecord (){
      axios({
        method: "post",
        url: "https://api.ufaeasy888.com/recreateuser",
        data: {
          id: this.params.data.key,
        }
      }).then(async response => {
        console.log(response.data)
          //if (response.data && response.data.status) {
            //this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
          //}
      });
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.firstname} ${this.params.data.lastname}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      const emailKey = this.params.data.email.trim().replace(/\./g, '||');
      firebase.database().ref().child(`users/${emailKey}`).remove().then(() =>{
        this.showDeleteSuccess()
        this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
      });
      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
